import * as React from "react";
import { BarChart } from "@mui/x-charts";
import { valueFormatter } from "./valueFormat";

export default function Sales({ sales, datesInRange }) {
  return (
    <BarChart
      dataset={sales}
      series={[
        { dataKey: "online", label: "Online", valueFormatter },
        { dataKey: "offline", label: "Offline", valueFormatter },
      ]}
      style={{ width: "100%", height: "400px" }}
      xAxis={[{ data: datesInRange, scaleType: "band" }]}
    />
  );
}
